const moment = require("moment");

/**
 * 获取距离今天几天前的连续日期数组
 * @static
 * @alias module:Date.getRangeDateArr
 * @since 1.0.0
 * @returns {Array} 数组
 *
 * @example
 *  getRangeDateArr(3);
 *  // => [ '2020-07-14', '2020-07-15', '2020-07-16' ]
 */

const getRangeDateArr = day => {
    let arr = []
    while (day > 0) {
        const date = moment()
            .subtract(day, "days")
            .format("YYYY-MM-DD");
        arr.push(date);
        day--;
    }
    return arr
};

export default getRangeDateArr;
